<template>
  <img :src="src" @load="$emit('loaded', $el)" />
</template>
<script>
export default {
  name: 'EditorItemContentImage',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  watch: {
    src() {
      if (this.$el.complete) {
        return;
      }
      this.$emit('loading', this.$el);
    }
  },
  mounted() {
    this.$emit('loading', this.$el);
  }
};
</script>
